


























import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class ResultDialog extends Vue {
  private isActive = false;
  private resultMessage = "";

  public open(resultMessage: string) {
    this.resultMessage = resultMessage;
    this.isActive = true;
  }
}
